import React from "react";
import Accordion from "react-bootstrap/Accordion";
const FAQs=()=>{

    return(

        <>
        <div style={{display:"flex",alignItems:"center"}}>

<div className="card shadow myprofileCard " >
<div className="card-body overFlow p-md-3">

   

<Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header> <b>What is the SSO Portal?</b></Accordion.Header>
              <Accordion.Body>
            <p>The SSO (Single Sign-On) Portal is a unified digital gateway that provides citizens with seamless access to 10 different Delhi Development Authority services using a single set of login credentials.</p>  
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header><b> Why was the SSO Portal created?</b></Accordion.Header>
              <Accordion.Body>
              <p>The SSO Portal was developed to simplify the user experience by combining multiple DDA applications into one secure platform, reducing the need for multiple logins and improving service accessibility.</p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header><b> What services can I access through the SSO Portal?</b></Accordion.Header>
              <Accordion.Body>
              You can access 10 integrated DDA services, including but not limited to:
                <ul>
<li>AWAAS/BHOOMI</li>
<li>Online Water Bill</li>
<li>Online Booking for Halls and Open Spaces</li>
<li>VLMS</li>
<li>IDLI</li>
<li>New Payroll</li>
<li>LMIS</li>
<li>OPD</li>
<li>Expression of Willingness</li>
<li>Citizen Centric Services</li>


                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header><b>How do I register on the SSO Portal?</b></Accordion.Header>
              <Accordion.Body>
              Citizen Registration:
                <ul>
                    <li>Visit the SSO Portal homepage (https://ssoportal.com/)</li>
                    <li>Click on Citizen</li>
                    <li>Enter your email/mobile number post which you will receive a 6-digit OTP on the provided details. Enter the OTP and click on Register.</li>
                    <li>If you are a New User then you will get a registration form where you need to provide the required personal details (e.g. First Name, Last Name, etc)</li>
                    <li>Set your login credentials by entering your unique username and password. You will receive your credentials on you shared mobile number and email id after final registration.</li>
                    <li>Post creating your login you can select on DDA Departments from side bar go to DDA Departments and select:
Housing:
AWAAS - Verify PAN by entering the OTP received on registered mobile number.
Bhoomi- Enter PAN/Aadhar for verification
Citizen Centric Services:

Land Disposal
IDLI
Others:
Reimbursement System-OPD – Select your medical card number from the list and you will be redirected to the OPD Portal of DDA.
Online Water Bill – Select your Consumer ID from the list and you will be redirected to the water bill portal of DDA.
E-MB – Login Using Mobile Number
Expression of Willingness for participation under land pooling scheme-Select File number
New Payroll-Login Using Mobile Number
</li>




                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header><b>What are eligibility criteria?</b></Accordion.Header>
              <Accordion.Body>
              Eligibility for registering in a scheme is as under -
              <ul>
<li>The applicant must be a citizen of India.</li>
<li>He should have attained the age of majority i.e. an applicant should have completed 18 years of age as on the date of submitting the application.</li>
<li>The applicant must not own any dwelling unit (including residential plot)/flat in full or in part on lease hold or freehold basis in Delhi, New Delhi or Delhi Cantonment, either in his/her own name or in the name of his/her spouse or in the name of any of the dependent relations including unmarried children.</li>
<li>Family means spouse and dependent relations including unmarried children.</li>
<li>Both husband and wife can apply for flats separately subject to fulfilment of eligibility conditions with the stipulations that if both are found to be successful only one shall be allotted a flat.</li>
<li>One person can submit one application only either in his/her own name or as a joint applicant.</li>
<li>A person who has already been allotted a plot/house/flat by the DDA or any other land owning agency in Delhi, irrespective of size, shall not be eligible to apply for another flat under the scheme.</li>
<li>There is no income criterion, except for applicants applying for EWS flats. The applicant can apply according to his/her requirement and affordability.</li>

<li>The income of applicants applying for EWS flats should not exceed Rs.1 lakh per annum.</li>
<li>The applicant should have an account in any bank and the particulars must be filled in the application form. It is assumed that the bank has followed KYC norms of RBI in respect of such account.</li>
<li>Applicant must have PAN allotted under the provisions of Income Tax act and the same should be quoted in the application form except when applying for an EWS flat.</li>
<li>In case of joint application under SC/ST reserved category, the joint applicant should be from the within the Family as defined above.</li>
<li>XIII.	In case of joint application under war widows, persons with disabilities’, ex-servicemen reserved categories, the applicant himself/herself should fall within the reserved category and the joint applicant should be from the Family as defined above.</li>


              </ul>
              </Accordion.Body>
            </Accordion.Item>
            {/* <Accordion.Item eventKey="5">
              <Accordion.Header>Water Bill</Accordion.Header>
              <Accordion.Body>
                ABCD
              </Accordion.Body>
            </Accordion.Item> */}
          
            
          </Accordion> 


          </div>
          </div>

          </div>
        
        </>



        
    )



}

export default FAQs;